import { initBotId } from 'botid/client/core'
import { shouldSuppressCapabilityTelemetry } from './src/utils/capabilityPrivacy'

// SpotMe lead forms submit via Apollo to spotme-server (cross-origin),
// not via Next.js API routes — so BotID can't attach to those requests
// directly. Instead the forms make a pre-flight POST to /api/botid/verify
// before calling their Apollo mutation. That single route is the only
// path BotID needs to attach challenge headers to.
//
// Soft-flag policy: verify never blocks the lead submission. The signal
// is logged to PostHog + Datadog; sales triages in HubSpot.
// See docs/marketing/botid.md for the full pipeline.
if (!shouldSuppressCapabilityTelemetry())
  initBotId({
    protect: [
      { path: '/api/botid/verify', method: 'POST' },
      // Paid anonymous-calculator ops (pages/api/calc/[op].ts) — the route
      // answers 403 { code: 'BOT' } and the photo step degrades gracefully.
      { path: '/api/calc/upload-urls', method: 'POST' },
      { path: '/api/calc/suggest', method: 'POST' }
    ]
  })
